export default __webpack_public_path__ + "images/desktop-bg-pin.png?5e7e096055d4e8c15460317c53dc610b";